import clsx from 'clsx';
import Boto from '../Boto/Boto';
import styles from './modulbutlleti.module.scss';
import Icona from '../../../components/3catinfo/ui/Icona';
import { useId } from 'react';
import { useViewport } from 'hooks/3catinfo/useViewport';

const ModulButlleti = (props) => {
    const { titol, text, textBoto, route, estil, imgFons, imgFonsMobile } = props;
    const stylesModul = clsx(styles.modulButlleti, estil && styles[estil]);
    const stylesDinsItemNoti = clsx(styles.contentModul, estil === 'noticia' && styles.itemNoticia);
    const { isMobile } = useViewport();
    const img = isMobile && imgFonsMobile ? imgFonsMobile : imgFons;
    const componentId = useId().replace(/:/g, '-');
    return (
        <aside className={stylesDinsItemNoti} aria-labelledby={`modul-mirada-global-${componentId}`}>
            <div className={stylesModul} data-testid='newsletter' style={{ '--bg-imatge-butlleti': `url(${img})` }}>
                <div className={styles.wrapper}>
                    <div className={styles.content}>
                        <Icona inline={true} className={styles.icona} icona='sobre' ariaHidden={true} />
                        <h2 className={styles.titol} data-testid='newsletter-titol' id={`modul-mirada-global-${componentId}`}>
                            {titol}
                        </h2>
                        <p className={styles.text} data-testid='newsletter-text'>
                            {text}
                        </p>
                        <Boto className={styles.boto} text={textBoto} route={route} tema='negre' dataTestId='newsletter-boto' />
                    </div>
                </div>
            </div>
        </aside>
    );
};

export default ModulButlleti;
